export default __webpack_public_path__ + "static/media/ageIcon.a54a631d.svg";